module.exports = __webpack_public_path__ + "img/icon-media.ebb84b1f.svg";